/**
 * UserGetRes 类型和 Schema 定义
 *
 * ⚠️ 注意: 此文件由脚本自动生成，请勿手动修改
 * 如需更新，请运行代码生成脚本
 */
import type { SchemaDefinition } from './_schema'
import type { UserData } from './user_data'

/**
 * UserGetRes
 */
export interface UserGetRes {
  /** 用户详情 */
  items?: UserData[]
}

/**
 * UserGetRes Schema
 */
export const UserGetResSchema: SchemaDefinition = {
  properties: {
    items: {
      description: '用户详情',
      format: '[]*model.UserData',
      items: { $ref: 'UserData', description: '' },
      type: 'array',
      label: '用户详情',
    },
  },
  type: 'object',
}
